var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-text-field"},[_c('div',{staticClass:"field-title"},[_vm._v(_vm._s(_vm.fieldTitle))]),_c('TextField',{attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }